export function getLocationId(location) {
  return location?.id ?? location?.location_id;
}

export function getLocationName(location) {
  return location?.name ?? location?.location_name ?? '';
}

export function getLocationStatus(location) {
  const status = location?.locationStatus ?? location?.location_status ?? '';
  return String(status).toLowerCase();
}

export function isDraftLocation(location) {
  return getLocationStatus(location) === 'draft';
}

export function isDisabledLocation(location) {
  return getLocationStatus(location) === 'disabled';
}

export function getLocationStatusColor(location) {
  if (isDisabledLocation(location)) return '#EF4444';
  if (isDraftLocation(location)) return '#CECE12';
  return '#2C313A';
}

export function getLocationDisplayName(entity) {
  return entity?.name ?? entity?.location_name ?? '';
}

export function getAnalyticsId(entity) {
  return entity?.gAnalyticsId ?? entity?.g_analytics_id ?? '';
}

export function getPropertyDisplayName(entity) {
  return entity?.property_name ?? entity?.propertyName ?? entity?.name ?? '';
}

export function getCompanyDisplayName(entity) {
  return entity?.company_name ?? entity?.companyName ?? entity?.name ?? '';
}
